import { Component, ViewChild } from '@angular/core';
import { DownloadsCatalogKeys } from '../../model/DownloadsCatalogKeys';
import { CatalogPaginationRequest } from 'src/app/features/shared/models/CatalogPagination/CatalogPaginationRequest';
import { FilterRequest } from 'src/app/features/shared/models/Filter/FilterRequest';
import { firstValueFrom, Observable, Subscription, take } from 'rxjs';
import { DownloadsTableComponent } from '../downloads-table/downloads-table.component';
import { DownloadsCenterService } from '../../service/DownloadsCenter.service';

@Component({
  selector: 'downloads-list',
  templateUrl: './downloads-list.component.html',
  styleUrls: ['./downloads-list.component.css']
})
export class DownloadsListComponent {

  dummyDownloads = [
    {
      Id: 'e1f2a3b4-c5d6-7890-abcd-234567890abc',
      CreatedBy: 'juan.perez@email.com',
      CreatedIn: '11/09/2025',
      TypeMapixDownloadRequest: 'Reporte de Historicos',
      StatusMapixDownloadRequest: 'Terminado'
    },
    {
      Id: 'f2a3b4c5-d6e7-8901-bcde-345678901bcd',
      CreatedBy: 'maria.garcia@email.com',
      CreatedIn: '12/09/2025',
      TypeMapixDownloadRequest: 'Reporte de Historicos',
      StatusMapixDownloadRequest: 'En proceso'
    },
    {
      Id: 'a3b4c5d6-e7f8-9012-cdef-456789012cde',
      CreatedBy: 'carlos.lopez@email.com',
      CreatedIn: '13/09/2025',
      TypeMapixDownloadRequest: 'Reporte de Historicos',
      StatusMapixDownloadRequest: 'Error'
    },
    {
      Id: 'b4c5d6e7-f8a9-0123-def0-567890123def',
      CreatedBy: 'ana.martinez@email.com',
      CreatedIn: '14/09/2025',
      TypeMapixDownloadRequest: 'Reporte de Historicos',
      StatusMapixDownloadRequest: 'Terminado'
    },
    {
      Id: 'c5d6e7f8-a9b0-1234-ef01-678901234ef0',
      CreatedBy: 'luis.gomez@email.com',
      CreatedIn: '15/09/2025',
      TypeMapixDownloadRequest: 'Reporte de Historicos',
      StatusMapixDownloadRequest: 'En proceso'
    },
    {
      Id: 'd6e7f8a9-b0c1-2345-f012-789012345f01',
      CreatedBy: 'sofia.fernandez@email.com',
      CreatedIn: '16/09/2025',
      TypeMapixDownloadRequest: 'Reporte de Historicos',
      StatusMapixDownloadRequest: 'Error'
    },
    {
      Id: 'e7f8a9b0-c1d2-3456-0123-890123456012',
      CreatedBy: 'diego.sanchez@email.com',
      CreatedIn: '17/09/2025',
      TypeMapixDownloadRequest: 'Reporte de Historicos',
      StatusMapixDownloadRequest: 'Terminado'
    },
    {
      Id: 'f8a9b0c1-d2e3-4567-1234-901234567123',
      CreatedBy: 'laura.ruiz@email.com',
      CreatedIn: '18/09/2025',
      TypeMapixDownloadRequest: 'Reporte de Historicos',
      StatusMapixDownloadRequest: 'En proceso'
    },
    {
      Id: 'a9b0c1d2-e3f4-5678-2345-012345678234',
      CreatedBy: 'javier.torres@email.com',
      CreatedIn: '19/09/2025',
      TypeMapixDownloadRequest: 'Reporte de Historicos',
      StatusMapixDownloadRequest: 'Error'
    },
    {
      Id: 'b0c1d2e3-f4a5-6789-3456-123456789345',
      CreatedBy: 'patricia.ramirez@email.com',
      CreatedIn: '20/09/2025',
      TypeMapixDownloadRequest: 'Reporte de Historicos',
      StatusMapixDownloadRequest: 'Terminado'
    }
  ];

  @ViewChild(DownloadsTableComponent) child;
    
      columnHeader : DownloadsCatalogKeys = {
        Id: { displayName: "Id", filterable: false, activeFilter: null },
        CreatedBy: { displayName: "Solicitado Por", filterable: false, activeFilter: null },
        CreatedIn: { displayName: "Fecha de solicitud", filterable: false, activeFilter: null },
        TypeMapixDownloadRequest: { displayName: "Procedencia", filterable: false, activeFilter: null },
        StatusMapixDownloadRequest: { displayName: "Estatus", filterable: false, activeFilter: null }
      };
    
      catalogPaginationRequest: CatalogPaginationRequest = {
              page: 1,
              dato: "",
              getInactive: false,
              filters: []
      }
    
      hasInactives: boolean = true;
      hasEditables: boolean = true;
      hasDeletables: boolean = true;    
      filtersRequest : FilterRequest[] = [];
      filterOptions: { [key: string]: string[] } = {};
    
      tableData$: Observable<any[]> = new Observable<any[]>();
      tableData: any[];
      controllerName: string;
      paginador: number;
    
      subscription_getData: Subscription;
      subscription_getDataCount: Subscription;
      subscription_getDataFileterValues: Subscription;
    
      constructor(public downloadCenterService: DownloadsCenterService) {
        this.controllerName = "DownloadsCenter"
      }
    
      ngOnInit() {
        
      }

      ngAfterViewInit(): void {
        this.EndSubscriptions();
        // this.getFilters();
        this.getData();
      }
    
      ngOnDestroy(): void {
        this.EndSubscriptions();
      }
    
      EndSubscriptions(){
        if(this.subscription_getData)
          this.subscription_getData.unsubscribe();
        if(this.subscription_getDataCount)
          this.subscription_getDataCount.unsubscribe();
        if(this.subscription_getDataFileterValues)
          this.subscription_getDataFileterValues.unsubscribe();
      }
    
      getFilters(){
        var filterKeys = Object.keys(this.columnHeader).filter(key => this.columnHeader[key].filterable);
        this.filtersRequest = filterKeys.map(key => ({
          key: key,
          value: "" 
        }));
        this.subscription_getDataFileterValues = this.downloadCenterService.getFilterValues(this.filtersRequest).subscribe(data=>{
          filterKeys.forEach(column => {
            this.filterOptions[column] = data.result.find(x => x.key == column).values;
          });
          console.log("filterValues datos",data, this.filterOptions);
        },(error)=>{
    
        });
      }
    
      async getData(){
        // const [getCount, getData] = await Promise.all([
        //         firstValueFrom(this.downloadCenterService.getCount(this.catalogPaginationRequest).pipe(take(1))),
        //         firstValueFrom(this.downloadCenterService.getPage(this.catalogPaginationRequest).pipe(take(1)))
        //       ]);
              
        // if (getCount.isSuccess) {
        //   this.paginador = getCount.result[0];
        // }
  
        // if (getData.isSuccess) {
        //   this.tableData = getData.result;
        //   this.child.setData(this.tableData, this.paginador);
        // }

        this.child.setData(this.dummyDownloads, 20);

      }

}
